export default __webpack_public_path__ + "static/media/img.e6d30cf3.png";